import themeConfig from '@configs/themeConfig'

const SpinnerComponent = () => {
  return (
    <div className='fallback-spinner app-loader'>
      <img className='fallback-logo' src={themeConfig.app.appLogoImage} alt='logo' width={200} />
      <div className='loading'>
        <div className='effect-1 effects'/>
        <div className='effect-2 effects'/>
        <div className='effect-3 effects'/>
      </div>
    </div>
  )
}

export default SpinnerComponent
